import styled from 'styled-components';
import IconSearchDark from 'assets/icon-search-dark.svg';
import {DashboardInner} from 'components/DashboardInner/styles';

export const EmailMarketingSubHeadline = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #172751;
  margin-bottom: 24px;
`;

export const StatCardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  &.three {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 899px) {
    grid-template-columns: 1fr;

    &.three {
      grid-template-columns: 1fr;
    }
  }
`;

export const StatCard = styled(DashboardInner)`
  border-radius: 12px;
  margin-top: 0;
  padding: 19px 20px 22px 20px;

  @media (max-width: 767px) {
    padding: 19px 16px 22px 16px;
  }
`;

export const StatCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 13px;

  img {
    width: 30px;
    height: 30px;
    flex: 0 0 auto;
  }
`;

export const StatCardTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 100%;
  color: #2f3d48;
`;

export const StatCardBody = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
`;

export const StatCardValue = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 42px;
  font-weight: 275;
  line-height: 100%;
  color: #2f3d48;
`;

export const StatCardDelta = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;
  color: #17c981;
`;

export const StatCardHint = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  color: #b3b9c2;
  text-align: right;
  max-width: 167px;
`;

export const SettingsMenuWrapper = styled.div`
  position: relative;
  flex: 0 0 auto;
`;

export const SettingsMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 240px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(23, 39, 81, 0.16);
  padding: 8px 0;
  z-index: 5;
`;

export const SettingsMenuItem = styled.button`
  display: block;
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 12px 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  color: #172751;
  cursor: pointer;

  &:hover {
    background-color: #f7f7fa;
  }

  &:disabled {
    color: #929cb9;
    cursor: default;
    background-color: transparent;
  }
`;

export const CampaignsCard = styled(DashboardInner)`
  border-radius: 16px;
  margin-top: 24px;
  padding: 46px 26px 26px 26px;

  /* The shared pagination brings its own top border, which doubles up with the
     last row's divider. */
  .EmailMarketingPagination {
    border-top: none;
    margin-top: 8px;
  }

  @media (max-width: 767px) {
    padding: 24px 16px;
  }
`;

export const CampaignsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 899px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const CampaignsTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
  color: #2f3d48;
`;

export const CampaignsControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > span {
    white-space: nowrap;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 100%;
    color: #172751;
  }

  .Say2EatDrop {
    min-width: 180px;

    .MuiOutlinedInput-root {
      height: 56px;
    }

    .MuiSelect-select {
      display: flex;
      align-items: center;
      height: 56px;
      padding-top: 0;
      padding-bottom: 0;
      box-sizing: border-box;
    }
  }

  input {
    background-color: #f7f7fa;
    background-image: url('${IconSearchDark}');
    border: 1px solid #d5d8de;
    border-radius: 6px;
    height: 56px;
    min-width: 260px;
    background-position: center left 14px;
    padding-left: 42px;

    &::placeholder {
      color: #172751;
    }
  }

  @media (max-width: 899px) {
    flex-wrap: wrap;

    /* The search field wraps its input in a div, which would otherwise shrink
       to fit while the select stretches. */
    > div {
      width: 100%;
    }

    input {
      min-width: 0;
      width: 100%;
    }
  }
`;

export const CampaignsTableWrapper = styled.div`
  .MuiTableRow-root {
    vertical-align: middle;
  }

  .MuiTableBody-root .MuiTableRow-root {
    border-bottom: 1px solid #929cb9;

    &.clickable {
      cursor: pointer;

      &:hover {
        background-color: #f7f7fa;
      }
    }
  }

  .MuiTableHead-root {
    border-bottom: 1px solid #929cb9;
  }

  .MuiTableCell-root {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 100%;
    color: #172751;
    border-bottom: none;
    padding: 18px 8px;
    vertical-align: middle;

    &:first-child {
      padding-left: 0;
    }

    /* Row action column, flush to the table edge. */
    &:last-child {
      padding-right: 1px;
      text-align: right;
    }
  }

  .MuiTableHead-root .MuiTableCell-root {
    font-weight: 700;
    padding-bottom: 15px;
  }
`;

export const CampaignSubject = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  color: #172751;
`;

export const CampaignLastSent = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 100%;
  color: #b3b9c2;
  margin-top: 8px;
`;

export const CampaignStatus = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 800;
  line-height: 100%;
  color: #929cb9;

  &.active {
    color: #17c981;
  }
`;

export const CampaignRowButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;

  &:focus-visible {
    outline: 2px solid #ff2d38;
    outline-offset: 2px;
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

export const CampaignsEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #929cb9;
  padding: 40px 0;
  text-align: center;

  img {
    width: 48px;
    height: 48px;
    opacity: 0.6;
  }
`;

export const CampaignBackLink = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  border: none;
  background: transparent;
  padding: 0;
  margin-bottom: 16px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 100%;
  color: #2f3d48;
  cursor: pointer;
  outline: none;

  &:focus-visible {
    outline: 2px solid #ff2d38;
    outline-offset: 2px;
  }
`;

export const CampaignDetailCard = styled(DashboardInner)`
  border-radius: 16px;
  margin-top: 0;
  margin-bottom: 24px;
  padding: 23px 25px 25px 25px;

  &.tiles {
    padding: 24px 25px 34px 25px;
  }

  /* The last row's own padding is the card's bottom spacing. */
  &.rows {
    padding-bottom: 0;
  }

  @media (max-width: 767px) {
    padding: 20px 16px;

    /* The modifiers outrank a bare padding here, so they repeat. */
    &.tiles {
      padding: 20px 16px 24px 16px;
    }
  }
`;

export const CampaignDetailTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
  color: #2f3d48;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    font-size: 20px;
  }
`;

export const CampaignDetailPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CampaignDetailPill = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  color: #929cb9;
  border: 1px solid #d5dae4;
  border-radius: 11px;
  padding: 0 10px;

  img {
    width: 12px;
    height: 12px;
    flex: 0 0 auto;
  }

  &.active {
    color: #17c981;
    border-color: rgba(23, 201, 129, 0.5);
  }
`;

export const CampaignTiles = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 599px) {
    flex-direction: column;
  }
`;

export const CampaignTile = styled.div`
  flex: 1 1 0;
  text-align: center;

  @media (max-width: 599px) {
    padding: 12px 0;
  }
`;

export const CampaignTileValue = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 42px;
  font-weight: 275;
  line-height: 100%;
  color: #2f3d48;
  margin-bottom: 13px;

  &.green {
    color: #17c981;
  }

  @media (max-width: 899px) {
    font-size: 32px;
  }
`;

export const CampaignTileName = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 100%;
  color: #b3b9c2;
`;

export const CampaignDetailColumns = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 899px) {
    flex-direction: column;
  }

  > * {
    flex: 1 1 0;
    width: 100%;
    margin-bottom: 0;
    padding: 23px 36px 13px;
  }

  @media (max-width: 767px) {
    > * {
      padding: 20px 16px;
    }
  }
`;

export const CampaignSectionTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  color: #2f3d48;
  margin-bottom: 20px;
`;

export const CampaignFunnel = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 18px;
  /* Padding, not margin: a margin here would collapse into the title's. */
  padding-top: 14px;
`;

export const CampaignFunnelStage = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CampaignFunnelCount = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  color: #2f3d48;
  margin-bottom: 34px;
`;

export const CampaignFunnelTrack = styled.div`
  position: relative;
  width: 100%;
  height: 184px;
  background-color: #e8eaef;
  border-radius: 10px;
  overflow: hidden;
`;

export const CampaignFunnelFill = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #5cc489;
`;

export const CampaignFunnelLabel = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  color: #929cb9;
  margin-top: 13px;
`;

export const CampaignPreviewFrame = styled.iframe`
  width: 100%;
  height: 520px;
  border: 1px solid #eceef3;
  border-radius: 8px;
  background-color: #fff;
`;

export const CampaignPreviewEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  min-height: 200px;
  padding: 24px;
  border: 1px dashed #d5dae4;
  border-radius: 8px;

  font-family: 'Poppins', sans-serif;
  color: #929cb9;
  font-size: 14px;

  strong {
    color: #172751;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const CampaignDetailRow = styled.div`
  display: flex;
  align-items: baseline;

  &:last-child > div:last-child {
    border-bottom: none;
  }
`;

export const CampaignDetailLabel = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #2f3d48;
  flex: 0 0 125px;
  padding: 13px 0;

  @media (max-width: 767px) {
    flex-basis: 110px;
  }
`;

/* In Figma the divider runs under the value column only, not the full row. */
export const CampaignDetailValue = styled.div`
  flex: 1 1 auto;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  color: #2f3d48;
  padding: 13px 0;
  border-bottom: 1px solid #e3e6ec;
  word-break: break-word;

  &.green {
    color: #17c981;
  }
`;

export const EmailMarketingSpinner = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
`;
